import React, { useState, useEffect, useContext } from "react";

import { simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getChartDiaAsync } from "../../../api/Dashboard";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { chartPalette, chartTextColor, chartGridColor } from "../../../theme";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const money = (value) =>
  new Intl.NumberFormat("es-NI", {
    style: "currency",
    currency: "NIO",
  }).format(value);

const moneyShort = (value) =>
  new Intl.NumberFormat("es-NI", {
    style: "currency",
    currency: "NIO",
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value);

const ChartDia = ({ selectedSucursal }) => {
  const [labels, setLabels] = useState([]);
  const [data, setData] = useState([]);

  const { setIsLoading, setIsUnautorized, isDarkMode } = useContext(DataContext);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getChartDiaAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);

      let names = [];
      let val = [];
      result.data.result.forEach(function (i) {
        names.push(i.gestor);
        val.push(i.montoCobrado);
      });
      setLabels(names);
      setData(val);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSucursal]);

  const palette = chartPalette(isDarkMode, data.length || 1);
  const tick = chartTextColor(isDarkMode);
  const grid = chartGridColor(isDarkMode);

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += money(context.parsed.y);
            }
            return label;
          },
        },
      },
    },

    scales: {
      x: {
        ticks: { color: tick },
        grid: { display: false },
      },
      y: {
        ticks: {
          color: tick,
          callback: (value) => moneyShort(value),
        },
        grid: { color: grid },
        beginAtZero: true,
      },
    },
  };

  const dataSet = {
    labels,
    datasets: [
      {
        data: data,
        backgroundColor: palette.bg,
        borderColor: palette.border,
        borderWidth: 1,
        borderRadius: 6,
      },
    ],
  };

  return (
    <div style={{ height: "100%" }}>
      <Bar data={dataSet} options={options} />
    </div>
  );
};

export default ChartDia;
